module.exports = __webpack_public_path__ + "img/educational-assistance.6fd4b554.jpg";